"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MelhorEnvioFetchOtherError = exports.MelhorEnvioFetchClientError = exports.MelhorEnvioFetchServerError = exports.AxiosTestError = void 0;
class AxiosTestError extends Error {
    constructor({ message = 'Axios Test Error', config = '', code = '', request = '', response = '' }) {
        super(message);
        this.config = config;
        this.code = code;
        this.request = request;
        this.response = response;
        this.isAxiosError = true;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.AxiosTestError = AxiosTestError;
class AxiosError extends Error {
    constructor(message, config, code, request, response) {
        super(message);
        this.config = config;
        this.code = code;
        this.request = request;
        this.response = response;
    }
}
class MelhorEnvioFetchServerError extends AxiosError {
    constructor(message, config, code, request, response) {
        super(message, config, code, request, response);
        this.name = 'MelhorEnvioFetchServerError';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.MelhorEnvioFetchServerError = MelhorEnvioFetchServerError;
class MelhorEnvioFetchClientError extends AxiosError {
    constructor(message, config, code, request) {
        super(message, config, code, request);
        this.name = 'MelhorEnvioFetchClientError';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.MelhorEnvioFetchClientError = MelhorEnvioFetchClientError;
class MelhorEnvioFetchOtherError extends AxiosError {
    constructor(message, config) {
        super(message, config);
        this.name = 'MelhorEnvioFetchOtherError';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.MelhorEnvioFetchOtherError = MelhorEnvioFetchOtherError;
//# sourceMappingURL=fetch.js.map